
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img" />
    </ion-button>
  </ion-menu-toggle>

  <div class="SCWEB-address-container" (click)="openAddress($event)">
    <p>{{userService.user ?
        (userService.user.address ? (userService.user.address | addressShort) : 'Select an address')
        : 'Select an address'}}</p>
    <ion-icon name="md-create"></ion-icon>
  </div>

  <div class="page-wrapper">

    <div class="name-img-wrapper">
      <img [src]="accountUser.imgURL" class="img" (click)="uploadPicPressed()" />
      <div class="name">{{accountUser.fullName}}</div>
    </div>

    <div class="middle-info">

      <div class="section-header">Personal information</div>

      <ion-item *ngIf="userService.isConcierge()" class="input-item" lines="none">
        <ion-label>{{userService.user.conciergeName}}</ion-label>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="accountUser.email" name="email" type="email" #email="ngModel" required
          placeholder="Email">
        </ion-input>
        <ion-button slot="end" fill="clear" (click)="saveEmail()">Save</ion-button>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-label>{{accountUser.phone}}</ion-label>
      </ion-item>

      <div *ngIf="!userService.isBusinessConcierge()">
        <div class="section-header">Payment method</div>

        <ion-item class="input-item clickable" lines="none" (click)="updatePayment()">
          <ion-icon class="start-icon" slot="start" name="card-outline"></ion-icon>
          <ion-label> {{ paymentCardString }} </ion-label>
          <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
        </ion-item>
      </div>

      <div class="section-header">Other options</div>

      <ion-item class="input-item clickable" lines="none" (click)="openPage('https://getshortcut.co/pros')">
        <ion-icon class="start-icon" slot="start" name="cut-outline"></ion-icon>
        <ion-label>Become a Shortcut Pro</ion-label>
        <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-item>

      <ion-item class="input-item clickable" lines="none" (click)="enterPromoCode()">
        <ion-icon class="start-icon" slot="start" name="pricetags-outline"></ion-icon>
        <ion-label>Enter a promo code</ion-label>
        <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-item>

      <!-- <ion-item class="input-item clickable" lines="none">
        <ion-icon class="start-icon" slot="start" name="gift"></ion-icon>
        <ion-label>Gift cards</ion-label>
        <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-item> -->

      <!-- <ion-item class="input-item clickable" lines="none">
        <ion-icon class="start-icon" slot="start" name="cut"></ion-icon>
        <ion-label>Get free cuts</ion-label>
        <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-item> -->

      <p class="reset-pass-button" (click)="resetPassword()">Reset password</p>
      <p class="log-out-button" (click)="logOut()">Log out</p>

    </div>

    <div class="support-footer">
      <span class="support-button" (click)="openPage('https://getshortcut.co/faq')">FAQ</span>
      <span class="support-button" (click)="adminChat()">Live chat</span>
      <span class="support-button" (click)="emailFromBrowser()">Email us</span>
      <span class="support-button" (click)="openPage('https://getshortcut.co/privacy')">Privacy policy</span>
      <span class="support-button" (click)="openPage('https://getshortcut.co/terms')">Terms of service</span>
    </div>
  </div>

</ion-content>